export const SET_MAIN_MENU = 'SET_MAIN_MENU';
export const SET_MAIN_MENU_MORE = 'SET_MAIN_MENU_MORE';
export const SET_USER_MENU = 'SET_USER_MENU';
export const SET_ABOUT_MENU = 'SET_ABOUT_MENU';
